import { config } from "@/config";
const AliadoService = {
    async getAll(search) {
        const token = localStorage.getItem("accessToken");
        const params = new URLSearchParams();
        if (search)
            params.append("search", search);
        const response = await fetch(`${config.API_URL}/api/Aliado?${params.toString()}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok)
            throw new Error("Error al obtener aliados");
        return await response.json();
    },
    async getById(id) {
        const token = localStorage.getItem("accessToken");
        const response = await fetch(`${config.API_URL}/api/Aliado/${id}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok)
            throw new Error("Error al obtener aliado");
        return await response.json();
    },
    async buscarClienteByRif(rif) {
        const token = localStorage.getItem("accessToken");
        const response = await fetch(`${config.API_URL}/api/Aliado/buscar-cliente/${rif}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok)
            throw new Error("Error al buscar cliente");
        return await response.json();
    },
    async register(dto, file) {
        const token = localStorage.getItem("accessToken");
        const formData = new FormData();
        Object.keys(dto).forEach((key) => {
            const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
            formData.append(pascalKey, dto[key]);
        });
        if (file)
            formData.append("file", file);
        const response = await fetch(`${config.API_URL}/api/Aliado`, {
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            body: formData,
        });
        if (!response.ok)
            throw new Error("Error al registrar aliado");
        return await response.json();
    },
    async update(id, dto, file) {
        const token = localStorage.getItem("accessToken");
        const formData = new FormData();
        Object.keys(dto).forEach((key) => {
            const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
            formData.append(pascalKey, dto[key]);
        });
        if (file)
            formData.append("file", file);
        const response = await fetch(`${config.API_URL}/api/Aliado/${id}`, {
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
            body: formData,
        });
        if (!response.ok)
            throw new Error("Error al actualizar aliado");
        return await response.json();
    },
    async toggleActivo(id) {
        const token = localStorage.getItem("accessToken");
        const response = await fetch(`${config.API_URL}/api/Aliado/${id}/toggle-activo`, {
            method: "PATCH",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok)
            throw new Error("Error al cambiar estado del aliado");
        return await response.json();
    },
    async delete(id) {
        const token = localStorage.getItem("accessToken");
        const response = await fetch(`${config.API_URL}/api/Aliado/${id}`, {
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok)
            throw new Error("Error al eliminar aliado");
        return await response.json();
    },
    async addSucursal(aliadoId, dto, file) {
        const token = localStorage.getItem("accessToken");
        const formData = new FormData();
        Object.keys(dto).forEach((key) => {
            const val = dto[key];
            // Convert key to PascalCase for C# DTO binding
            const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
            if (key === "responsableIds" && Array.isArray(val)) {
                val.forEach((id) => formData.append("ResponsableIds", id.toString()));
            }
            else if (val !== null && val !== undefined) {
                formData.append(pascalKey, val);
            }
        });
        if (file)
            formData.append("file", file);
        const response = await fetch(`${config.API_URL}/api/Aliado/${aliadoId}/sucursales`, {
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            body: formData,
        });
        if (!response.ok)
            throw new Error("Error al agregar sucursal");
        return await response.json();
    },
    async updateSucursal(id, dto, file) {
        const token = localStorage.getItem("accessToken");
        const formData = new FormData();
        Object.keys(dto).forEach((key) => {
            const val = dto[key];
            // Convert key to PascalCase for C# DTO binding
            const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
            if (key === "responsableIds" && Array.isArray(val)) {
                val.forEach((id) => formData.append("ResponsableIds", id.toString()));
            }
            else if (val !== null && val !== undefined) {
                formData.append(pascalKey, val);
            }
        });
        if (file)
            formData.append("file", file);
        const response = await fetch(`${config.API_URL}/api/Aliado/sucursales/${id}`, {
            method: "PUT",
            headers: { Authorization: `Bearer ${token}` },
            body: formData,
        });
        if (!response.ok)
            throw new Error("Error al actualizar sucursal");
        return await response.json();
    },
    async toggleSucursalActivo(id) {
        const token = localStorage.getItem("accessToken");
        const response = await fetch(`${config.API_URL}/api/Aliado/sucursales/${id}/toggle-activo`, {
            method: "PATCH",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok)
            throw new Error("Error al cambiar estado de la sucursal");
        return await response.json();
    },
    async deleteSucursal(id) {
        const token = localStorage.getItem("accessToken");
        const response = await fetch(`${config.API_URL}/api/Aliado/sucursales/${id}`, {
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok)
            throw new Error("Error al eliminar sucursal");
        return await response.json();
    },
};
export default AliadoService;
